export class IconConfig {
  fill?: string = 'primary';
  type?: string;
  set?: string;
  transform?: string;

  constructor(options = {}) {
    Object.assign(this, options);
  }
}

export class StarIconConfig {
  fill?: string = 'primary--text';
  type?: string;
  set?: string;
  transform?: string;

  constructor(options = {}) {
    Object.assign(this, options);
  }
}
